// ** React Imports
import {createContext, useEffect, useState} from 'react';

// ** Create Context
const ThemeColorsContext = createContext();

const ThemeColorsProvider = ({children}) => {
  // ** State
  const [colors, setColors] = useState({});

  //** ComponentDidMount
  useEffect(() => {
    // Get computed styles from document body
    const getHex = color =>
        window.getComputedStyle(document.body).getPropertyValue(color).trim();

    // Define object with color variables and values
    const obj = {
      primary: {
        light: getHex('--primary').concat('1a'),
        main: getHex('--primary')
      },
      secondary: {
        light: getHex('--secondary').concat('1a'),
        main: getHex('--secondary')
      },
      success: {
        light: getHex('--success').concat('1a'),
        main: getHex('--success')
      },
      danger: {
        light: getHex('--danger').concat('1a'),
        main: getHex('--danger')
      },
      warning: {
        light: getHex('--warning').concat('1a'),
        main: getHex('--warning')
      },
      info: {
        light: getHex('--info').concat('1a'),
        main: getHex('--info')
      },
      dark: {
        light: getHex('--dark').concat('1a'),
        main: getHex('--dark')
      }
    };

    // Set state with color object
    setColors({...obj});
  }, []);

  // Render context provider with colors object
  return (
      <ThemeColorsContext.Provider value={{colors}}>
        {children}
      </ThemeColorsContext.Provider>
  );
};

// Export context and provider
export {ThemeColorsContext as ThemeColors, ThemeColorsProvider as ThemeContext};
